
export class InterceptTimer
{
	constructor(
		readonly setInterceptReady: (ready:boolean) => void
	) {}

	private timer = null;

	arm() 
	{
		if (this.timer != null) { 
			clearTimeout(this.timer); 
			this.timer = null;
		}

		this.setInterceptReady(false);

		this.timer = setTimeout(() => { 
			this.timer = null; 
			this.setInterceptReady(true);
		}, 300);
	}

	disarm() 
	{
		if (this.timer != null) { 
			clearTimeout(this.timer); 
			this.timer = null;
		}
		this.setInterceptReady(false);
	}
}

